import Logos from "../components/sidebar/Logos";
import { Link } from "react-router-dom";

import "../styles/screens/TermsOfService.scss";

export default function TermsOfService() {
    return (
        <section className="TermsOfService">            
            <div className="back-button">
                <Link to={{ pathname: "/" }}>Back to EPYC Explorer</Link>
            </div>
            <div className="branding">                
                <Logos />                
            </div>            
            <div className="text-content">
                <h1>Terms of Service</h1>
                <h2>EPYC Explorer Official Rules</h2>   
                <p>These terms govern participation in EPYC Explorer during the Program Period (the “Incentive”). By accepting these terms, Google and Advanced Micro Devices, Inc. (AMD) Participants consent to participation in this Incentive. The promoter of the Incentive is Advanced Micro Devices Inc., whose principal place of business is at 2485 Augustine Drive Santa Clara, CA 95054 (AMD).</p>

                <h2>Program Period</h2>
                <p>The Incentive begins on April 22, 2025 and ends on September 30, 2025 at 5:00 p.m. (PDT) (“Program Period”).</p>

                <h2>Eligibility</h2>
                <ul>
                    <li>The Incentive is open to:</li>
                    <ol>
                        <li>Google Cloud sales representatives and sales managers (i.e. Field Sales Reps “FSRs”, Customer Engineers “CEs”), marketing, and partner and product managers with a valid @google.com email address</li>
                        <li>Advanced Micro Devices, Inc. sales representatives and sales managers (i.e. Account Executives and Territory Executives “AEs and TEs” and Cloud Specialists) with a valid @amd.com email address</li>
                        <li>Winners must be employees of Google and Advanced Micro Devices, Inc.</li>
                    </ol>
                    <li>The Incentive is void where prohibited by law.</li>
                    <li>Individuals from the same organization as any end user or customer are not eligible to participate in the Incentive.</li>
                </ul>

                <h2>Entry Process</h2>
                <ol>
                    <li>Participant will be sent a competition invite by or before September 30, 2025.</li>
                    <li>Participant completes the registration form provided to Participants via EPYC Explorer webpage: <Link to={{ pathname: "/" }}>epycexplorer.com</Link></li>
                    <ol style={{ listStyleType: "lower-alpha" }}>
                        <li>Accepts these Official Rules.</li>
                        <li>Submits first name, last name, valid @google.com or @amd.com email address, phone number, job title, company, segment, vertical, region, and mailing address. By submitting, it is Participants consent for these details to be submitted to AMD, and used by AMD and its Partners with respect to the Incentive. This includes consent for AMD and AMD Partners to contact the Participant with respect to the Incentive.</li>                        
                    </ol>
                    <li>Participants will be sent a URL link to EPYC Explorer sign up page</li>
                </ol>

                <h2>Participation</h2>
                <ul>
                    <li>Throughout the Incentive, Participants will complete Google Cloud and AMD on-demand learning courses on the EPYC Explorer learning platform, powered by Google Firebase.</li>
                    <li>If Participant is an eligible Google employee:</li>
                    <ul>
                        <li>To participate in EPYC Explorer, Participant must:</li>
                        <ul>
                            <li>Complete on-demand learning courses on the third-party platform, Google Firebase </li>
                            <li>EPYC Explorer consists of twelve (12) training courses and <strong>three (3) prize levels</strong>. Prizes vary per level based on completion of training courses. Each training course must be completed at 100% of the total on-demand training video minutes to be considered completed (i.e. if a training course is ten (10) minutes long, Participant must watch ten (10) minutes of the video for the training course to be considered completed).</li>
                            <li>Google and/or Google Partner will track learning course completion among Google Cloud Participants through the Google Firebase System</li>
                        </ul>
                    </ul>
                    <li>If Participant is an eligible Advanced Micro Devices, Inc. employee:</li>
                    <ul>
                        <li>To participate in EPYC Explorer, Participant must:</li>
                        <ul>
                            <li>Complete on-demand learning courses on the third-party platform, Google Firebase</li>
                            <li>EPYC Explorer consists of twelve (12) training courses and <strong>three (3) prize levels</strong>. Each training course must be completed at 100% of the total on-demand training video minutes to be considered completed (i.e. if a training course is ten (10) minutes long, Participant must watch ten (10) minutes of the video for the training course to be considered completed).</li>
                            <li>Google and or Google Partner will track learning course completion among AMD Participants through the Google Firebase System </li>
                        </ul>
                    </ul>
                    <li>If Participant is an eligible Google employee:</li>
                    <ul>
                        <li>To participate in EPYC Explorer Raffle, Participant must:</li>
                        <ul>
                            <li>Tag Advanced Micro Devices as the opportunity partner in Google Vector for relevant GCE and GKE opportunities. Opportunity must be for N2D, T2D, C2D, C3D, C4D and/or H4D virtual machines. Each tag will count as 1 entry into the raffle. Raffle entries are unlimited.</li>
                            <ul>
                                <li>Workspan Referral Instructions:</li>
                                <ul>
                                    <li>Navigate to the opportunity - go/myvector</li>
                                    <li>Click on Opportunity Partners under the Related List Quick Links</li>
                                    <li>Click New</li>
                                    <li>In the pop-up, search and select “Advanced Micro Devices, Inc.” as the Partner Account and select “Build” as the Partner Type</li>
                                    <li>Check the Pre-Close Contribution as “Involved” and check the “Is Sourced?” box if applicable</li>
                                    <li>Save</li>
                                </ul>
                            </ul>
                            <li>1 winner in each region (NA, EMEA, LATAM, APAC) will be selected by October 20th, 2025</li>
                        </ul>
                    </ul>
                </ul>

                <h2>How To Win for Google Cloud Participant:</h2>
                <p>The prizes will be awarded as follows:</p>
                <ol>
                    <li>Prize Level One</li>
                    <li>Prize Level Two</li>
                    <li>Prize Level Three</li>
                    <li>Raffle Prize</li>                    
                </ol>
                <ol>
                    <li>Prize Level One</li>
                    <ol>
                        <li>Complete all 3 sessions included within the: Quantum Apartments</li>
                        <ol style={{ listStyleType: "lower-alpha" }}>
                            <li>Session Title 1 + quiz question</li>
                            <li>Session Title 2 + quiz question</li>
                            <li>Session Title 3 + quiz question</li>
                        </ol>
                    </ol>
                    <li>Prize Level Two</li>
                    <ol>
                        <li>Complete all 3 sessions included within the: Transit Hub</li>
                        <ol style={{ listStyleType: "lower-alpha" }}>
                            <li>Session Title 1 + quiz question</li>
                            <li>Session Title 2 + quiz question</li>
                            <li>Session Title 3 + quiz question</li>
                        </ol>
                    </ol>
                    <li>Prize Level Three</li>
                    <ol>
                        <li>Complete all 3 sessions included within the: Work Sector</li>
                        <ol style={{ listStyleType: "lower-alpha" }}>
                            <li>Session Title 1 + quiz question</li>
                            <li>Session Title 2 + quiz question</li>
                            <li>Session Title 3 + quiz question</li>
                        </ol>
                    </ol>
                    <li>Raffle Prize</li>
                    <ol>
                        <li>Submit a Workspan referral to AMD in Vector for relevant GCE and GKE opportunities.</li>
                    </ol>
                </ol>

                <h3>Completion of Prize Level One</h3>
                <ul>
                    <li>One (1) Google Cloud and AMD branded electric salt and pepper grinder</li>                    
                </ul>

                <h3>Completion of Prize Level Two</h3>
                <ul>
                    <li>One (1) Google Cloud and AMD branded Tile Mate</li>                    
                </ul>

                <h3>Completion of Prize Level Three</h3>
                <ul>
                    <li>One (1) Google Cloud and AMD branded desk vacuum </li>                    
                </ul>

                <p>For clarity:</p>
                <ul>
                    <li>The maximum number of prizes any one Participant can be awarded is up to 3  items for an AMD participant and up to 4 items for a Google participant</li>
                    <li>A participant is eligible to receive only one (1) prize per level listed above. Participants may not win multiple prizes within the same level or receive multiple items.</li>
                </ul>

                <h2>Prizes</h2>
                <ul>
                    <li>AMD-approved 3rd party vendors will distribute the swag to prize winners.</li>
                    <li>AMD reserves the right to substitute any prize with an alternate prize of comparable value.</li>
                    <li>Participants will be prompted to provide their shipping information for prizes upon registering on the EPYC Explorer webpage. Prize winners can also navigate to the “Edit your profile” button to provide shipping information. Prize winners will be awarded based on their completion during the Program Period.</li>
                    <li>Prize winners shipping information must be completed and submitted during the Program Period. Failure to do so by the end of the Program Period will relinquish AMD from having to send out the prize(s)</li>
                    <li>Prizes will be delivered to the winners by on or about March 31, 2026.</li>
                    <li><strong>Prizes given to Participants are received with the consent of Participant and are not intended to improperly influence the recipient in any way. Prizes received by Participant are not to be used to bribe or otherwise improperly influence any other party. Accepting a Prize does not create any obligation for Participant to make decisions in favor of AMD/Google or make any decisions that are not in the best interests of Participant.</strong></li>
                </ul>

                <h2>General</h2>
                <ul>
                    <li>All federal, state, provincial and local laws and regulations apply. AMD reserves the right to disqualify any Participant from the Program if, in AMD’s discretion, it reasonably believes that the Participant has attempted to undermine the legitimate operation of the Program by cheating, deception, or other unfair playing practices or abuses, or threatens or harasses any other participants or AMD.</li>
                    <li>The prizes cannot be exchanged for cash and are non transferable.</li>
                    <li>Any prizes awarded may be subject to local tax for the individual recipient. AMD is not liable for any tax liabilities from the Incentive.</li>
                    <li>The prizes must not be transferred to any customer or potential customer.</li>
                    <li>These Official Rules are governed by the laws of the State of California and subject to the exclusive jurisdiction of the Santa Clara County courts in relation to any dispute (contractual or non-contractual) concerning these Official Rules or the Incentive.</li>
                </ul>

                <h2>Privacy</h2>
                <ul>
                    <li>Participant agrees and acknowledges (and warrants that all data subjects also agree and acknowledge) that personal data submitted to claim prizes, including name, mailing address, phone number, job title, segment, region, vertical, company, and email address may be collected, processed, stored and otherwise used by AMD and its affiliates for the purposes of conducting and administering the Incentive. Such information will be maintained in accordance with AMD's Privacy Policy, <a href="https://www.amd.com/en/legal/privacy.html" target="_blank" rel="noreferrer">https://www.amd.com/en/legal/privacy.html</a></li>
                </ul>
            </div>
            <div className="back-button">
                <Link to={{ pathname: "/" }}>Back to EPYC Explorer</Link>
            </div>
        </section>
    )
}